var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("異業點數")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("點數/商品兌換活動")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row align-items-start align-items-xl-center justify-content-between mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v("點數/商品兌換活動")]), _c('div', {
    staticClass: "col-12 col-xl-10 d-flex flex-column flex-xl-row align-items-start align-items-xl-center justify-content-xl-end"
  }, [_vm.checkPermission([_vm.consts.PARTNER_MARKETING_EVENT_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.goCreate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 新增點數/商品兌換活動 ")]) : _vm._e(), _c('b-form-select', {
    staticClass: "ml-2",
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "value": _vm.type,
      "options": _vm.typeOptions
    },
    on: {
      "input": function input($event) {
        return _vm.updateFilter('type', $event);
      }
    }
  }), _c('b-form-select', {
    staticClass: "ml-2",
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "value": _vm.is_processing,
      "options": _vm.isProcessingOptions
    },
    on: {
      "input": function input($event) {
        return _vm.updateFilter('is_processing', $event);
      }
    }
  }), _c('b-form-select', {
    staticClass: "ml-2",
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "value": _vm.status,
      "options": _vm.statusOptions
    },
    on: {
      "input": function input($event) {
        return _vm.updateFilter('status', $event);
      }
    }
  }), _c('b-input-group', {
    staticClass: "ml-0 ml-xl-4",
    staticStyle: {
      "max-width": "220px",
      "flex": "1 1 0"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入名稱、序號或商品號碼"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch.apply(null, arguments);
      }
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.list,
      "fields": _vm.fields,
      "busy": _vm.isLoading,
      "show-empty": "",
      "sort-by": "sort",
      "sort-desc": false
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "head(active_plans_count)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.label) + " "), _c('BIconQuestionCircle', {
          staticClass: "d-inline-block ml-1",
          attrs: {
            "id": "active-plans-count-tooltip"
          }
        }), _c('b-popover', {
          attrs: {
            "target": "active-plans-count-tooltip",
            "triggers": "hover focus"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v(" 【1個活動需至少建立1筆方案，才能顯示於前台】 ")])])];
      }
    }, {
      key: "cell(image_url)",
      fn: function fn(data) {
        return [data.item.image_url ? _c('b-img-lazy', {
          staticStyle: {
            "width": "80px",
            "height": "80px",
            "object-fit": "contain"
          },
          attrs: {
            "src": data.item.image_url
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(is_active)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.isActive(data.item) ? 'success' : 'warning'
          }
        }, [_vm._v(" " + _vm._s(_vm.isActive(data.item) ? '上架' : '下架') + " ")])];
      }
    }, {
      key: "cell(type)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.item.type === 'serial' ? 'primary' : 'success'
          }
        }, [_vm._v(" " + _vm._s(data.item.type === 'serial' ? '序號' : data.item.type === 'product' ? '商品' : data.item.type) + " ")])];
      }
    }, {
      key: "cell(status)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.statusMap[data.item.status] ? _vm.statusMap[data.item.status].variant : 'secondary'
          }
        }, [_vm._v(" " + _vm._s(_vm.statusMap[data.item.status] ? _vm.statusMap[data.item.status].text : data.item.status) + " ")])];
      }
    }, {
      key: "cell(start_at)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.start_at)) + " ")];
      }
    }, {
      key: "cell(end_at)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.end_at)) + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "size": "sm",
            "variant": "inverse-info",
            "to": {
              name: 'PartnerMarketingPlanListByEvent',
              params: {
                partnerMarketingEventId: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil mr-1"
        }), _vm._v("管理方案")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "inverse-primary"
          },
          on: {
            "click": function click($event) {
              return _vm.goView(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye mr-1"
        }), _vm._v("查看")]), _vm.checkPermission([_vm.consts.PARTNER_MARKETING_EVENT_MODIFY]) ? _c('b-button', {
          staticClass: "ml-1",
          attrs: {
            "size": "sm",
            "variant": "inverse-warning"
          },
          on: {
            "click": function click($event) {
              return _vm.goEdit(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil mr-1"
        }), _vm._v("編輯")]) : _vm._e(), _vm.checkPermission([_vm.consts.PARTNER_MARKETING_EVENT_DELETE]) ? [_c('span', {
          attrs: {
            "id": "delete-btn-".concat(data.item.id)
          }
        }, [_c('b-button', {
          staticClass: "ml-1",
          attrs: {
            "size": "sm",
            "variant": "inverse-danger",
            "disabled": data.item.status !== 'closed'
          },
          on: {
            "click": function click($event) {
              return _vm.remove(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete mr-1"
        }), _vm._v("刪除")])], 1), data.item.status !== 'closed' ? _c('b-tooltip', {
          attrs: {
            "target": "delete-btn-".concat(data.item.id),
            "placement": "top"
          }
        }, [_vm._v("發布狀態為關閉時，才能刪除")]) : _vm._e()] : _vm._e()];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.page,
      "totalRows": _vm.pagination.total,
      "perPage": _vm.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }